export enum SystemRolesAdditionalPermissionsToExistsGroupsIds {
  'notInTeam' = 'notInTeam',
  notifications = 'notifications',
}
